import globals from '@/util/globals';

const longDateTime = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
};

const shortDateTime = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
};

const shortDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
};

const shortDateOfYear = {
    month: 'short',
    day: 'numeric',
};

const time = {
    hour: 'numeric',
    minute: 'numeric',
};

const formatters = {
    time,
    shortDate,
    shortDateTime,
    longDateTime,
    shortDateOfYear,
};

const timeZone = globals.timeZone();
const dateTimeFormatters = !timeZone
    ? formatters
    : Object.keys(formatters)
        .reduce(
            (acc, key) => ({
                ...acc,
                [key]: {
                    ...formatters[key],
                    timeZone,
                },
            }),
            {},
        );

export default {
    en: dateTimeFormatters,
    de: dateTimeFormatters,
    nl: dateTimeFormatters,
    es: dateTimeFormatters,
    fr: dateTimeFormatters,
    'pt-BR': dateTimeFormatters,
};
